export default __webpack_public_path__ + "static/media/calltoarms.fb4eb8ec.png";